import { EyeOutlined } from "@ant-design/icons";
import { Button, Drawer} from "antd";
import CustomAgGridServer from "app/shared/AgGridServer";
import React, { useEffect, useMemo, useRef, useState } from "react";


const Transaction : React.FC = () => {

    const [drawerOpen, setDrawerOpen] = useState(false);
const [selectedLink, setSelectedLink] = useState("");

    const gridRef=useRef(null);
    const columnDefs = useMemo(() => [

        // ================= BASIC =================
        { headerName: "Load ID", field: "load_id", filter: "agTextColumnFilter", width: 130, enableRowGroup: true },
        { headerName: "Customer Name", field: "name_of_the_recipient", filter: "agTextColumnFilter", width: 150, enableRowGroup: true },
        { headerName: "File Name", field: "file_name", filter: "agTextColumnFilter",width: 160, enableRowGroup: true },
        { headerName: "Transaction ID", field: "transaction_id", filter: "agTextColumnFilter", width: 220, enableRowGroup: true },
      
        // ================= INVOICE =================
        { headerName: "Invoice Type", field: "document_type", filter: "agTextColumnFilter", width: 150, enableRowGroup: true },
        { headerName: "Invoice Number", field: "invoice_number", filter: "agTextColumnFilter", width: 180, enableRowGroup: true },
        { headerName: "Invoice Date", field: "invoice_date", filter: "agDateColumnFilter", width: 150, enableRowGroup: true },
        { headerName: "Invoice Status", field: "invoice_status", filter: "agTextColumnFilter", width: 170, enableRowGroup: true,pinned: "right"},
        { headerName: "Invoice Ref", field: "invoice_ref", filter: "agTextColumnFilter", width: 150, enableRowGroup: true },
        { headerName: "Invoice Link", field: "invoice_link", filter: "agTextColumnFilter", width: 150, enableRowGroup: true },
        {
            headerName: "View Invoice",
            field: "asset_link",
            width: 160,
            pinned: "right",
            cellRenderer: (params: any) => {
              const status = params.data?.invoice_status;
              const link = params.data?.asset_link;
          
              if (status === "Invoice Received" && link) {
                return (
                  <div
                    style={{ display: "flex", alignItems: "center", cursor: "pointer", color: "#1677ff" }}
                    onClick={() => {
                        setSelectedLink(link);
                        setDrawerOpen(true);
                      }}
                  >
                    <EyeOutlined style={{ marginRight: 6 }} />
                    <span>View</span>
                  </div>
                );
              } else{
                return <span style={{ color: "#999" }}>Not Available</span>;
              }
          
              return null;
            },
          },
      
        // ================= CUSTOMER / VENDOR =================
        { headerName: "File Name 1", field: "file_name_1", filter: "agTextColumnFilter", width: 150, enableRowGroup: true },
        { headerName: "Customer GSTIN", field: "customer_gstin", filter: "agTextColumnFilter", width: 180, enableRowGroup: true },
        { headerName: "Customer PAN", field: "customer_pan", filter: "agTextColumnFilter", width: 150, enableRowGroup: true },
        { headerName: "Vendor", field: "vendor", filter: "agTextColumnFilter", width: 150, enableRowGroup: true },
        { headerName: "Supplier GSTIN", field: "supplier_gstin", filter: "agTextColumnFilter", width: 180, enableRowGroup: true },
      
        // ================= GST =================
        { headerName: "Taxable Value", field: "taxable_value", filter: "agNumberColumnFilter", width: 150, enableRowGroup: true },
        { headerName: "IGST Amount", field: "igst_amt_", filter: "agNumberColumnFilter", width: 150, enableRowGroup: true },
        { headerName: "CGST Amount", field: "cgst_amt_", filter: "agNumberColumnFilter", width: 150, enableRowGroup: true },
        { headerName: "SGST Amount", field: "sgst_utgst_amt_", filter: "agNumberColumnFilter", width: 150, enableRowGroup: true },
        { headerName: "CESS Amount", field: "cess_amount_", filter: "agNumberColumnFilter", width: 150, enableRowGroup: true },
        { headerName: "Total GST", field: "total_gst", filter: "agNumberColumnFilter", width: 150, enableRowGroup: true },
      
        // ================= RATES =================
        { headerName: "IGST Rate", field: "igst_rate_", filter: "agNumberColumnFilter", width: 120, enableRowGroup: true },
        { headerName: "CGST Rate", field: "cgst_rate_", filter: "agNumberColumnFilter", width: 120, enableRowGroup: true },
        { headerName: "SGST Rate", field: "sgst_utgst_rate_", filter: "agNumberColumnFilter", width: 120, enableRowGroup: true },
        { headerName: "CESS Rate", field: "cess_rate_", filter: "agNumberColumnFilter", width: 120, enableRowGroup: true },
      
        // ================= AMOUNTS =================
        { headerName: "Total Amount", field: "total_amount", filter: "agNumberColumnFilter", width: 150, enableRowGroup: true },
        { headerName: "Discount", field: "discount", filter: "agNumberColumnFilter", width: 120, enableRowGroup: true },
        { headerName: "Net Sale Price", field: "net_sale_price_after_discount_", filter: "agNumberColumnFilter", width: 180, enableRowGroup: true },
      
        // ================= PRODUCT =================
        { headerName: "Item Code", field: "item_code", filter: "agTextColumnFilter", width: 150, enableRowGroup: true },
        { headerName: "Quantity", field: "quantity", filter: "agNumberColumnFilter", width: 120, enableRowGroup: true },
        { headerName: "HSN SAC", field: "hsn_sac", filter: "agTextColumnFilter", width: 140, enableRowGroup: true },
        { headerName: "HSN SAC Code", field: "hsn_sac_code", filter: "agTextColumnFilter", width: 140, enableRowGroup: true },
        { headerName: "Product Description", field: "product_service_description", filter: "agTextColumnFilter", flex: 1, enableRowGroup: true },
      
        // ================= LOCATION =================
        { headerName: "State", field: "state", filter: "agTextColumnFilter", width: 140, enableRowGroup: true },
        { headerName: "POS State", field: "pos_state_", filter: "agTextColumnFilter", width: 140, enableRowGroup: true },
        { headerName: "Ship From", field: "ship_from_state_", filter: "agTextColumnFilter", width: 140, enableRowGroup: true },
        { headerName: "Ship To", field: "ship_to_state_", filter: "agTextColumnFilter", width: 140, enableRowGroup: true },
      
        // ================= TRANSPORT =================
        { headerName: "Lorry Receipt Date", field: "lorry_receipt_date", filter: "agDateColumnFilter", width: 180, enableRowGroup: true },
        { headerName: "Lorry Receipt Number", field: "lorry_receipt_number", filter: "agTextColumnFilter", width: 180, enableRowGroup: true },
        { headerName: "Transporter Name", field: "transporter_name", filter: "agTextColumnFilter", flex: 1, enableRowGroup: true },
        { headerName: "Way Bill No", field: "way_bill_no", filter: "agTextColumnFilter", width: 150, enableRowGroup: true },
      
        // ================= E-INVOICE =================
        { headerName: "IRN", field: "irn", filter: "agTextColumnFilter", width: 200, enableRowGroup: true },
        { headerName: "IRN Status", field: "irn_status", filter: "agTextColumnFilter", width: 150, enableRowGroup: true },
        { headerName: "Ack No", field: "ackno", filter: "agTextColumnFilter", width: 150, enableRowGroup: true },
        { headerName: "Ack Date", field: "ackdt", filter: "agDateColumnFilter", width: 180, enableRowGroup: true },
      
        // ================= EWB =================
        { headerName: "EWB No", field: "ewb_no", filter: "agTextColumnFilter", width: 150, enableRowGroup: true },
        { headerName: "EWB Date", field: "ewb_date", filter: "agDateColumnFilter", width: 180, enableRowGroup: true },
        { headerName: "EWB Status", field: "ewb_status", filter: "agTextColumnFilter", width: 150, enableRowGroup: true },
        { headerName: "EWB Valid Upto", field: "ewb_valid_upto", filter: "agDateColumnFilter", width: 180, enableRowGroup: true },
      
        // ================= ACCOUNTING =================
        { headerName: "Accounting Year", field: "accounting_year", filter: "agNumberColumnFilter", width: 140, enableRowGroup: true },
        { headerName: "Accounting Month", field: "accounting_month", filter: "agNumberColumnFilter", width: 140, enableRowGroup: true },
        { headerName: "Accounting Date", field: "accounting_document_date", filter: "agDateColumnFilter", width: 180, enableRowGroup: true },
      
        // ================= SYSTEM =================
        { headerName: "API Status", field: "api_status", filter: "agTextColumnFilter", width: 140, enableRowGroup: true },
        { headerName: "Error Message", field: "error_message", filter: "agTextColumnFilter", flex: 2, enableRowGroup: true },
        { headerName: "Validation Message", field: "validation_message", filter: "agTextColumnFilter", flex: 2, enableRowGroup: true },
        { headerName: "Source System", field: "source_system", filter: "agTextColumnFilter", width: 150, enableRowGroup: true },
      
        // ================= FLAGS =================
        { headerName: "Is IRN", field: "is_irn", filter: "agSetColumnFilter", width: 120, enableRowGroup: true },
        { headerName: "Is EWB", field: "is_ewb", filter: "agSetColumnFilter", width: 120, enableRowGroup: true },
        { headerName: "Cancelled", field: "cancelled_flag", filter: "agSetColumnFilter", width: 120, enableRowGroup: true },
      
      ], []);
      
    return (
        <div style={{ display: "flex", height: "100%" }}>

        <div style={{ flex:1, padding:40 }}>
            <CustomAgGridServer
                //@ts-ignore
                        columnDefs={columnDefs}
                 //@ts-ignore
                        ref={gridRef}
                        endpoint="https://stage-apiplatform.finkraftai.com/api/qatar/table/data"
                        serverPayload={{
                          table: "qatar_new_table",
                        }}
                        enableCheckbox={false}
                        enableFilter={true}
                        enablePagination={false}
                        enableSort={true}
                        style={{height:"100%"}}
            />

            <Drawer
                    title="Invoice Preview"
                    placement="right"
                    width={700}
                    onClose={() => setDrawerOpen(false)}
                    open={drawerOpen}
                >
                    {selectedLink ? (
                    <>
                        <iframe
                        src={selectedLink}
                        title="Invoice"
                        width="100%"
                        height="95%"
                        style={{ border: "none" }}
                        />

                        {/* Fallback button */}
                        <div style={{ marginTop: 10 }}>
                        <a href={selectedLink} target="_blank" rel="noopener noreferrer">
                            Open in new tab
                        </a>
                        </div>
                    </>
                    ) : (
                    <p>No Invoice Available</p>
                    )}
      </Drawer>
        </div>
        </div>
    );
}

export default Transaction;